<template>
	<v-card
		variant="flat"
	>
		<v-card-title>
			<translate>
				Finalization + Fraud policy
			</translate>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col>
					<v-divider />
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<div class="text-subtitle-1">
						<translate>
							Fraud Policy
						</translate>
					</div>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<p>
						<translate>
							Unfortunately, fraudulent claims are a common occurrence in the insurance world. We do everything we can to track down fraudulent claims in order to keep the premium as low as possible for our customers. We record every claim notice carefully and investigate the claims where we suspect fraud. To do so, we use a number of innovative fraud detection systems that make it easier to recognise when someone is committing fraud.
						</translate>
					</p>
					<br>
					<p>
						<translate>
							Tulip Assist also works with all warning lists for insurance fraud. If we discover fraud, we add the person who committed fraud to all of these lists. This way, we prevent the perpetrator from committing fraud again, and we keep the premium low for our customers at the same time.
						</translate>
					</p>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-divider />
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<div class="text-subtitle-1">
						<translate>
							Finalizing claim notice
						</translate>
					</div>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-text-field
						:model-value="modelValue.location"
						variant="outlined"
						:label="$gettext('Location')"
						@update:model-value="updated => update('location', updated)"
					/>
				</v-col>
				<v-col>
					<v-text-field
						disabled
						:model-value="((new Date()).toLocaleDateString('nl-NL'))"
						:label="$gettext('Date')"
						variant="outlined"
					/>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col
					v-if="deductible !== null"
					cols="auto"
					align-self="center"
				>
					<v-alert
						color="orange"
						class="ma-0 small-alert-padding"
						density="compact"
					>
						<translate>Attention!</translate>
					</v-alert>
				</v-col>
				<v-col
					v-if="deductible !== null"
					align-self="center"
				>
					<translate>Make sure you have sufficient balance in your account for a quick claim settlement.</translate>
				</v-col>
				<v-col
					v-if="deductible !== null"
					cols="12"
				>
					<v-checkbox
						:model-value="modelValue.directDebit"
						color="primary"
						:error-messages="errors.directDebit"
						:label="$gettextInterpolate($gettext('I hereby authorize %{company_name} to automatically collect the deductible of €%{deductible_amount} from my bank account with number account number %{number} in the case that the claim is approved.'), {company_name: companyName, deductible_amount: deductible, number: userIBAN}, false)"
						hide-details
						@update:model-value="updated => update('directDebit', updated)"
					/>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col>
					<p>
						<translate>
							We would like to point out that we base our assessment of the claim on the information as entered in this claim form. We do not take into account changes in information that you later report to us.
						</translate>
					</p>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col>
					<v-checkbox
						:model-value="modelValue.truth"
						color="primary"
						:label="$gettext('I hereby declare that I have filled in all information completely and truthfully.')"
						hide-details
						@update:model-value="updated => update('truth', updated)"
					/>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col>
					<translate>
						We use the personal details provided by you for the assessment and settlement of your claim notice and other insurance purposes. You can read about it in our
					</translate>
					<a
						class="ml-1"
						target="_blank"
						:href="privacyRoute"
					>
						<translate>privacy policy</translate>
					</a>.
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import {
	cloneDeep, set,
} from 'lodash';

export default {
	name: 'ClaimFormComplete',
	props: {
		modelValue: {
			type: Object,
			required: true,
		},
		errors: {
			type: Object,
			required: true
		},
		deductible: {
			type: Number,
			required: false,
			default: null
		},
		companyName: {
			type: String,
			required: true
		},
		userIBAN: {
			type: String,
			required: true
		}
	},

	emits: ['update:model-value',],

	data () {
		return {
			privacyRoute: '/klantenservice/privacyverklaring',
		};
	},

	methods: {
		/**
		 * @param {string} key
		 * @param {string} value
		 */
		update (key, value) {
			const updated = cloneDeep(this.modelValue);

			set(updated, key, value);

			this.$emit('update:model-value', updated);
		}
	}
};
</script>
<style scoped>
hr {
	margin-top: 0px;
	margin-bottom: 0px;
	border-color: rgb(97, 97, 97);
}
</style>
